// Slice 1 name of the member screen, kept as a redirect to the members
// screen (memberView, under /admin/registration/members). Spread into
// registrationModuleRoutes.
const memberJourneyRoutes = [
    {
        path: "members-journey/:id",
        name: "memberJourneyView",
        redirect: (to) => ({ name: "memberView", params: { id: to.params.id } }),
    },
];

export default memberJourneyRoutes;
